// extracted by mini-css-extract-plugin
export default {"body":"PageWithHeaderAndFooter_body__Vgb9U","container":"PageWithHeaderAndFooter_container__PyItS"};